import "./index.scss";

import { Box, MenuItem, Modal, Stack } from "@mui/material";
import { ReactComponent as DeleteIcon } from "assets/images/square-buttons/close-small.svg";
import Button from "components/Button";
import ConfirmationBox from "components/ConfirmationBox";
import Dropdown from "components/Dropdown";
import { JOURNAL_ENTRY_CATEGORY } from "constants/index";
import { addJournalEntry, editJournalEntry } from "modules/member/memberServices";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { toast } from "react-toastify";

const JournalAddEditComp = ({ open, onClose, selectedData = null, memberId, callback = null }) => {
  const {
    handleSubmit,
    control,
    watch,
    register,
    formState: { errors },
    setValue,
  } = useForm<{ category: string; message: string }>({
    defaultValues: {
      category: JOURNAL_ENTRY_CATEGORY,
      message: "",
    },
  });

  useEffect(() => {
    setValue("message", selectedData?.message || "");
  }, [selectedData]);

  const [isLoading, setIsLoading] = useState(false);
  const [spellCheck, setSpellCheck] = useState(false);
  const [showDataWillBeLostModal, setShowDataWillBeLostModal] = useState(false);

  const message = watch("message");

  const handleSubmitForm = async (data) => {
    const fData = {
      ...data,
      member_id: memberId,
      // site,
    };
    setIsLoading(true);
    let result = null;
    if (selectedData) {
      result = await editJournalEntry(memberId, selectedData?.id, fData);
    } else {
      result = await addJournalEntry(fData);
    }
    setIsLoading(false);
    if (result.success) {
      if (selectedData) toast("Journal edit successful", { type: "success" });
      else toast("Journal entry successful", { type: "success" });
      if (callback) {
        callback();
      }
      onClose();
    } else {
      toast(result.message, { type: "error" });
    }
  };

  const onCloseConfirm = (discardChanges = false) => {
    if (discardChanges) {
      setShowDataWillBeLostModal(false);
      onClose();
    } else {
      setShowDataWillBeLostModal(false);
    }
  };

  return (
    <>
      <Modal open={open} onClose={() => setShowDataWillBeLostModal(true)}>
        <form onSubmit={handleSubmit(handleSubmitForm)}>
          <Box className="journal-add-edit-container">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              marginBottom="40px"
            >
              <h1 className="journal-modal-title">{!!selectedData ? `Edit` : `Add`} Record</h1>
              <DeleteIcon
                className="delete-icon"
                onClick={() => setShowDataWillBeLostModal(true)}
              />
            </Stack>

            <Stack direction={"row"} alignContent="center" gap="40px" mb={2}>
              <Box className="fieldLabel" pt={"14px"}>
                <label className="journal-record-label">Category</label>
              </Box>
              <Controller
                name="category"
                control={control}
                rules={{ required: true }}
                render={({ field: { onChange, value, ref } }) => (
                  <Stack spacing={1} flexGrow={1}>
                    <Dropdown
                      fullWidth
                      value={value}
                      onChange={(e) => {
                        onChange(e.target.value);
                      }}
                      disabled
                    >
                      <MenuItem value={JOURNAL_ENTRY_CATEGORY}>Journal Note</MenuItem>
                    </Dropdown>
                    {errors.category?.type === "required" && (
                      <h4 className="error">This field is required</h4>
                    )}
                  </Stack>
                )}
              />
            </Stack>

            <label className="journal-record-label">Journal Record</label>
            <Stack spacing={1}>
              <textarea
                className="journal-record-textarea"
                rows={9}
                placeholder="Please enter"
                spellCheck={spellCheck}
                {...register("message", {
                  required: true,
                })}
              />
              {errors.message?.type === "required" && (
                <h4 className="error">This field is required</h4>
              )}
              <Button
                type="button"
                style={{ marginTop: 20, width: 180 }}
                disabled={!!!message}
                label={"Spell Check"}
                color={"primary-blue"}
                onClick={() => setSpellCheck((p) => !p)}
              />
            </Stack>

            <Stack
              direction="row"
              mt="30px"
              justifyContent="flex-end"
              alignItems="center"
              spacing={3}
            >
              <Button
                type="button"
                disabled={isLoading}
                onClick={() => setShowDataWillBeLostModal(true)}
                className="text-button"
                label={"Cancel"}
              />
              <Button
                loading={isLoading}
                type="submit"
                className="confirm-button"
                label={"Confirm"}
              />
            </Stack>
          </Box>
        </form>
      </Modal>
      <ConfirmationBox
        open={showDataWillBeLostModal}
        onClose={onCloseConfirm}
        title={"Discard Changes?"}
        message={<>If answered Yes, all information filled will be lost.</>}
        type={"confirmation"}
      />
    </>
  );
};

export default JournalAddEditComp;
